import { ImCloudDownload } from 'react-icons/im';
import { IconButton, IconButton_IconSizes } from '@ydistri/ds';
import React from 'react';
import { addToast } from '@ydistri/utils';
import { useAppDispatch } from '../../../../store';
import { downloadBlob } from '../../YPickCredentials/yPickCredentialsLib';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void might be returned
export type TriggerDownloadFunction = () => Promise<Blob | void>;

interface AdministrationItemsDownloadButtonProps {
  fileName: string;
  disabled?: boolean;
  triggerDownload: TriggerDownloadFunction;
}

/**
 * Button to download entity list items as CSV file. Available to all entity list types (user, integration, etc.)
 * @param entityListId
 * @param disabled
 * @constructor
 */
const AdministrationItemsDownloadButton: React.FC<AdministrationItemsDownloadButtonProps> = ({
  fileName,
  triggerDownload,
  disabled = false,
}) => {
  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useAppDispatch();

  const handleDownloadClick = () => {
    setDownloading(true);
    dispatch(addToast({ message: 'Preparing files for download, please wait...' }));

    triggerDownload()
      .then(qrBlob => {
        if (qrBlob) {
          downloadBlob(qrBlob, fileName);
          dispatch(addToast({ message: 'Download completed' }));
        }
      })
      .catch((error: unknown) => {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Meh, I can't use the Error type in the callback and assertions are also no-go
        const err = error as Error;
        dispatch(
          addToast({
            message: `There was an issue when preparing the file: ${err.message}`,
            isError: true,
          }),
        );
      })
      .finally(() => {
        setDownloading(false);
      });
  };

  return (
    <IconButton
      icon={<ImCloudDownload size={IconButton_IconSizes.small} />}
      onClick={handleDownloadClick}
      disabled={disabled || downloading}
      tooltip="Download all items as CSV file"
      loading={downloading}
      size="small"
    />
  );
};

export default AdministrationItemsDownloadButton;
